import { render, staticRenderFns } from "./ShowCaseStudySection.vue?vue&type=template&id=0a32a195"
import script from "./ShowCaseStudySection.vue?vue&type=script&lang=js"
export * from "./ShowCaseStudySection.vue?vue&type=script&lang=js"
import style0 from "./ShowCaseStudySection.vue?vue&type=style&index=0&id=0a32a195&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports